import { render, staticRenderFns } from "./c-player__pdf.vue?vue&type=template&id=32feab28&scoped=true"
import script from "./c-player__pdf.vue?vue&type=script&lang=js"
export * from "./c-player__pdf.vue?vue&type=script&lang=js"
import style0 from "./c-player__pdf.vue?vue&type=style&index=0&id=32feab28&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32feab28",
  null
  
)

export default component.exports